import { makeStyles, mergeClasses, tokens } from "@fluentui/react-components";
import { useEffect, useState } from "react";

const useStyles = makeStyles({
    root: {
        transition: 'box-shadow 0.6s ease, border-color 0.6s ease',
    },
    emphasized: {
        border: `1px solid ${tokens.colorBrandBackground2}`,
        boxShadow: '0 0 0 3px rgba(37, 99, 235, 0.5)',
    },

});

export const useEmphasize = () => {

    //State
    const [emphasize, setEmphasize] = useState(false);

    //Styles
    const styles = useStyles();

    const emphasizeClasses = mergeClasses(
        styles.root,
        !!emphasize && styles.emphasized
    );

    const emphasizeElement = () => {
        setEmphasize(true);
    }

    useEffect(() => {
        if (emphasize) {
            const timer = setTimeout(() => setEmphasize(false), 500); // fades out after 1.5s
            return () => clearTimeout(timer);
        }
    }, [emphasize]);


    return {
        emphasizeClasses,
        emphasizeElement,
    }
}